import { render, staticRenderFns } from "./modalHorasExtrasBase.vue?vue&type=template&id=59698549&scoped=true&"
import script from "./modalHorasExtrasBase.vue?vue&type=script&lang=js&"
export * from "./modalHorasExtrasBase.vue?vue&type=script&lang=js&"
import style0 from "./modalHorasExtrasBase.vue?vue&type=style&index=0&id=59698549&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59698549",
  null
  
)

export default component.exports